import { useSelector } from 'react-redux';
import { useRouter, Redirect } from 'react-resource-router';

import FeatureGates from '@atlaskit/feature-gate-js-client';
import { StatsigFeatureKeys } from '@atlassian/bitbucket-features';

import { LANDING_PAGES } from 'src/components/repository-link/repository-link';
import { getCurrentRepositoryLandingPage } from 'src/selectors/repository-selectors';

const RespositoryRedirect = () => {
  const [{ match, location }] = useRouter();

  const enableClientSideLinking = FeatureGates.checkGate(
    StatsigFeatureKeys.enableClientSideLinking
  );
  const landingPage = useSelector(getCurrentRepositoryLandingPage);

  if (enableClientSideLinking && match.params.repositoryFullSlug) {
    const [owner, slug] = match.params.repositoryFullSlug.split('/');
    // Logic taken from repository-link.tsx for consistency
    // Defaults to source page when landing page is not defined
    const clientLandingPage =
      landingPage &&
      Object.prototype.hasOwnProperty.call(LANDING_PAGES, landingPage)
        ? LANDING_PAGES[landingPage]
        : LANDING_PAGES.source;

    const url = `${clientLandingPage.getHref(owner, slug)}${
      landingPage === 'source' ? location.search : ''
    }`;
    return <Redirect to={url} />;
  } else {
    const srcUrl = match.url.endsWith('/')
      ? `${match.url}src`
      : `${match.url}/src`;
    return <Redirect to={`${srcUrl}${location.search}`} />;
  }
};

export default RespositoryRedirect;
